import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { franchiseApi } from './api';

export const franchiseKeys = {
  all: ['franchise-admin'] as const,
  dashboard: ['franchise-admin', 'dashboard'] as const,
  stores: ['franchise-admin', 'stores'] as const,
  oc: ['franchise-admin', 'oc'] as const,
};

export const useFranchiseDashboard = () => useQuery({ queryKey: franchiseKeys.dashboard, queryFn: franchiseApi.dashboard });
export const useFranchiseStores = () => useQuery({ queryKey: franchiseKeys.stores, queryFn: franchiseApi.stores });
export const useFranchiseOc = () => useQuery({ queryKey: franchiseKeys.oc, queryFn: franchiseApi.oc });

// OC 관련 쓰기는 대시보드·매장 잔액·OC 화면에 모두 영향을 주므로 franchise-admin 전체를 무효화한다.
function useFranchiseMutation<TInput, TResult>(mutationFn: (input: TInput) => Promise<TResult>, extraKeys: string[][] = []) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: franchiseKeys.all }),
        ...extraKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
      ]);
    },
  });
}

export const useRequestOc = () => useFranchiseMutation(franchiseApi.requestOc);
export const useCancelOcRequest = () => useFranchiseMutation(franchiseApi.cancelOcRequest);
export const useAllocateOc = () => useFranchiseMutation(franchiseApi.allocateOc);
// 매장 관리자 목록은 ScopedDataPage가 ['scoped-data', ...] 키로 관리한다.
export const useSetStoreAdminStatus = () => useFranchiseMutation(franchiseApi.setStoreAdminStatus, [['scoped-data']]);
